import { atom } from 'jotai/vanilla';

const INTERNAL_BLOCKSUITE_HASH_MAP = /* @__PURE__ */ new Map([]);
const workspacePassiveAtomWeakMap = /* @__PURE__ */ new WeakMap();
const workspaceActiveWeakMap = /* @__PURE__ */ new WeakMap();
const workspacePassiveEffectWeakMap = /* @__PURE__ */ new WeakMap();
async function waitForWorkspace(workspace) {
  if (workspaceActiveWeakMap.get(workspace) !== true) {
    const providers = workspace.providers.filter(
      (provider) => "active" in provider && provider.active === true
    );
    for (const provider of providers) {
      provider.sync();
      await provider.whenReady;
    }
    workspaceActiveWeakMap.set(workspace, true);
  }
}
function getWorkspace(id) {
  if (!INTERNAL_BLOCKSUITE_HASH_MAP.has(id)) {
    throw new Error("Workspace not found");
  }
  return INTERNAL_BLOCKSUITE_HASH_MAP.get(id);
}
function getActiveBlockSuiteWorkspaceAtom(id) {
  if (!INTERNAL_BLOCKSUITE_HASH_MAP.has(id)) {
    throw new Error("Workspace not found");
  }
  const workspace = INTERNAL_BLOCKSUITE_HASH_MAP.get(id);
  if (!workspacePassiveAtomWeakMap.has(workspace)) {
    const baseAtom = atom(async () => {
      await waitForWorkspace(workspace);
      return workspace;
    });
    workspacePassiveAtomWeakMap.set(workspace, baseAtom);
  }
  return workspacePassiveAtomWeakMap.get(workspace);
}

export { INTERNAL_BLOCKSUITE_HASH_MAP, getActiveBlockSuiteWorkspaceAtom, getWorkspace, waitForWorkspace, workspaceActiveWeakMap, workspacePassiveEffectWeakMap };
